import styled from "styled-components";
import { colors } from "../../../constants";

export default styled.div`
    border: 1px solid ${colors.mediumTeal};
    border-radius: 6px;
    background-color: white;
`;
